import { h } from 'preact';
import * as BaseComp from 'components/bolt/header/headerExpanded.js';
import * as webp from 'utils/bolt/webp';
import Store from 'store/store';
import { accessNested, joinClasses } from 'utils/utils';
import { getRelativePageUrl, getValueForClientSize } from 'utils/bolt';
import { useDynamicAssetFolder } from 'utils/assets';

import HTML from 'components/core/html/html';
import Link from 'components/bolt/link/link';
import { navigateInternally, splitQueryAndPath } from 'utils/bolt/index';
import { getCopy } from 'utils/copy';

import s from 'components/bolt/header/headerExpanded.sss';

const isExternalLink = str => /^((https?:)|mailto:)/.test(str);
const getHref = (link) => (isExternalLink(link) ? link : getRelativePageUrl(link) || '#');
export default class HeaderExpanded extends BaseComp.default {
	constructor(props) {
		super(props);
        this.showFeaturedRef = { current: false };
	}

    toggleShowFeatured = () => {
        this.showFeaturedRef.current = !this.showFeaturedRef.current;
        this.forceUpdate();
    };
    

    renderLink(element, isFeatured) {
		// const isInternalLink = /^bolt/.test(element.path);
		let [pageIdRaw, hash] = element.path?.split('#') || [];
		let [pageId, queryStringRaw] = pageIdRaw?.split('?') || [];
		let queryString = element.queryString || (queryStringRaw ? `?${queryStringRaw}` : '');

		const page = accessNested(this.props, ['appData', 'pages', pageId]);
		const calendarEnabled = !!accessNested(this.props, 'appData.header.powsterHeader.calendars', null);
		const isInternalLink = !!page || element.path?.startsWith('@');
		const sizing = this.getLinkSizing(!isInternalLink);

		const activePage = this.props.activePage || 'boltHome';
		const activeSection = this.props.headerData.activeSection || 'boltHome';
		let active = activePage === pageId || (activePage === 'boltHome' && activeSection === element.path);
		const baseCopy = accessNested(this.props, 'appData.copy.baseCopy', {});
		let content = baseCopy[element.name] || element.name || element.id;
        const showFeatured = this.showFeaturedRef.current;

		// - start  - groupBookings same page 2 header items active 'hack'
		const groupBookingsEnabled = accessNested(this.props, 'appData.pages.boltShowtimes.data.groupBookings.isEnabled', false);
		if (groupBookingsEnabled && activePage == pageId && element.path === 'boltShowtimes' && queryString === '?groupbookings') {
			active = Store.get().groupBookingsShowtimes === true;
		}
		if (groupBookingsEnabled && activePage == pageId && element.path === 'boltShowtimes' && queryString === '?booknow') {
			active = Store.get().groupBookingsShowtimes === false;
		}
		//- end -

		if (page?.ageRestricted && this.props.client?.ofAge === false) {
			return;
		}

		if (element.path === 'boltShowtimes' && this.props.isCalendarRemindMode) {
			if (!calendarEnabled) return;
			content = baseCopy.$MENU_CALENDAR_REMINDER || 'Reminder';
		}

		let attributes = {};
		if (!element.disabled) {
			if (!isInternalLink) {
				attributes.href = element.path;
				attributes.target = element.sameWindow ? '_self' : '_blank';
				attributes.rel = 'noopener noreferrer';
				attributes.onClick = () => this.trackNavLink(content);
			} else {
				attributes.href = getRelativePageUrl(pageId, queryString, hash) || '#';
				attributes.onClick = element.onClick || (e => this.closeAndNavigate(pageId + (hash ? `#${hash}` : ''), e, content, queryString));
			}
		} else {
			attributes['aria-disabled'] = true;
		}

		const fontStyles = accessNested(this.props, 'appData.styling.fontVariables');
		const font = isFeatured ? fontStyles.navSecondaryLink : fontStyles.navPrimaryLink;

        if (element.path === 'map') {
            const originalClick = attributes.onClick;
            attributes.onClick = (e) => {
                if (originalClick) originalClick(e);
            };
        
            return (
                <div class={s.exploreBerkWrapper}>
                    <div class={s.exploreBerk}>
                        <Link
                            key={element.id || element.link || element.name}
                            class={joinClasses(s.link, active && s.active, sizing, font)}
                            {...attributes}
                        >
                            <HTML class={s.content} content={content} markdown />
                            <HTML class={s.hidden} content={content} aria-hidden markdown />
                        </Link>
                        <button
                            type="button"
                            onClick={this.toggleShowFeatured}
                            aria-label={showFeatured ? 'Hide Featured Links' : 'Show Featured Links'}
                            >
                            {showFeatured ? (
								<div class={s.buttonWrapper}>
									<div class={s.circleFill}></div>
									<svg class={s.minusIcon} width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
									<path d="M12 6L-3.57628e-07 6" stroke="currentColor" stroke-width="1.5"/>
									<path d="M12 6L-3.57628e-07 6" stroke="currentColor" stroke-width="1.5"/>
									</svg>
								</div>
                            ) : (
								<div class={s.buttonWrapper}>
									<div class={s.circleFill}></div>
									<svg class={s.plusIcon} width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
									<path d="M6 0V12" stroke="currentColor" stroke-width="1.5"/>
									<path d="M12 6L-3.57628e-07 6" stroke="currentColor" stroke-width="1.5"/>
									</svg>
								</div>
                            )}
                        </button>
                    </div>
                    <div class={joinClasses(s.featuredLinks, this.showFeaturedRef.current ? s.visible : s.hidden)}>
                        {this.featuredLinks.map(link => this.renderLink(link, true))}
                    </div>
                    <div class={s.navSeparator} />
                </div>
            );
        }

        if (element.path === 'posters') {
            return (
                <div>
                    <Link
                        key={element.id || element.link || element.name}
                        class={joinClasses(s.link, active && s.active, sizing, font)}
                        {...attributes}
                    >
                        <HTML class={s.content} content={content} markdown />
                        <HTML class={s.hidden} content={content} aria-hidden markdown />
                    </Link>
                    <div class={s.navSeparator} />
                </div>
            );
        }


		const NAV_LOCATIONS = ['map', 'workshop', 'house', 'village', 'arena', 'greatHall'];
		if (NAV_LOCATIONS.includes(element.path)) {
			const originalClick = attributes.onClick;
		
			attributes.onClick = (e) => {
				e.preventDefault();
				if (originalClick) originalClick(e);

				window.__manualMapReload();
				navigateInternally('map');
			
				const tryNavigateToLocation = () => {
					const isMapLoaded = document.querySelector('div[class*="_loaded"]')
					if (typeof window.navToLocation === 'function' && isMapLoaded) {
						window.navToLocation(element.path);
					} else {
						requestAnimationFrame(tryNavigateToLocation);
					}
				};
			
				tryNavigateToLocation();
			};
		}
		

		return (
			<Link
				key={element.id || element.link || element.name}
				class={joinClasses(s.link, active && s.active, sizing, font)}
				{...attributes}
			>
				<HTML class={s.content} content={content} markdown />
				<HTML class={s.hidden} content={content} aria-hidden markdown />
			</Link>
		);
	}

	onClick(e, path) {
        if (!path) return;
        e.preventDefault();

		if (path.startsWith('http') || path.startsWith('mailto:')) {
			let link = document.createElement('a');
			link.href = path;
			link.target = '_blank';
			link.style.display = 'none';
			document.body.appendChild(link);
			link.click();
			document.body.removeChild(link);
		} else {
			const { query, path: splitPath } = splitQueryAndPath(path);
			navigateInternally(splitPath, { queryString: query });
		}
	}

    renderFooter(){
        const footerData = accessNested(this.props, 'appData.footer.defaultFooter');
        const legalLogo = footerData?.logos?.studio?.src;
        const legalLogoAlt = footerData?.logos?.studio?.alt;
        const legalUrl = footerData?.logos?.studio?.url;
        const studioCopyright = footerData?.copyright?.studio?.$copy;
        const content = getCopy(studioCopyright, {}, '', null, 'baseCopy') || studioCopyright;
        const links = Object.values(footerData?.links).sort((a, b) => a.order - b.order);

        return (
            <div class={s.headerLegal}>
                <a href={legalUrl} target="_blank" rel="noopener noreferrer">
                    <img class={s.legalLogo} src={useDynamicAssetFolder(legalLogo)} alt={legalLogoAlt} />
                </a>
                <div class={s.copyright}>
                    <HTML class={s.copyrightText} content={content} markdown />
                </div>
                {/* <div class={s.legalLinks}>
                    {links.map(link => (
                        <a
                            onClick={(e) => this.onClick(e, link.url)}
                            target={link.target || '_blank'}
                            rel="noopener noreferrer"
                            aria-label={link.ariaLabel}
                            class={s.legalLink}
                        >
                            {getCopy(link.$copy) || link.$copy}
                        </a>
                    ))}
                </div> */}
            </div>
        )
    }

    render({ navOpen, showRegionSelector }) {
		const store = Store.get();
		let ttStyle;
		let { pushDown, cookieBannerOpen, height: cookieHeight } = store.cookies || {};
		const externalBannerOpen = accessNested(store, 'externalCookieBanner.bannerOpen');
		const bannerPushDown = externalBannerOpen || (pushDown && cookieBannerOpen);
		const sonyHeaderEnabled = accessNested(this.props, 'appData.options.sonyFeatures.sonyHeader', false);
		const bannerPushDownMobile = bannerPushDown && !accessNested(store, 'client.isDesktopSize', false);
		const copy = accessNested(this.props, 'appData.copy');
		const tt = accessNested(this.props, 'appData.header.powsterHeader.tt', null);
		const ttSize = this.getTTSize(tt);
		const isSplitHeader = this.isSplitHeader;
		const deviceSize = accessNested(this.props, 'client.deviceSize');
		let deviceBreakpoint = deviceSize;
		if (deviceSize !== 'mobile' && deviceSize !== 'tablet') {
			deviceBreakpoint = 'desktop';
		}
		const fallbackFormat = this.getFallbackFormat();

		if (bannerPushDown) {
			cookieHeight = accessNested(store, 'externalCookieBanner.height');
		}

		if (ttSize) {
			ttStyle = {
				width: '100%',
				height: '100%',
				maxWidth: ttSize.maxWidth,
				maxHeight: ttSize.maxHeight
			};
		}

		let links = [
			<div class={s.standard} key="standard">
				{tt && deviceBreakpoint in tt && (
					<webp.Picture
						style={ttStyle}
						class={s.tt}
						src={useDynamicAssetFolder(getValueForClientSize(tt))}
						alt={copy.accessibilityCopy[tt.alt] || tt.alt}
						fallbackFormat={fallbackFormat}
					/>
				)}

				{this.standardLinks.map(link => this.renderLink(link, false))}
			</div>
		];

		let paddingTop = sonyHeaderEnabled ? 34 : 0;
		if (bannerPushDown) {
			paddingTop += cookieHeight;
		}

		const totalLinks = this.standardLinks.length + this.featuredLinks.length;

		let isDesktop = true;
		if (deviceSize !== 'desktop' && deviceSize !== 'largeDesktop') {
			isDesktop = false;
		}
  
        const isLandscape = store?.client?.orientation === 'landscape';
        let isMobileLandscape = deviceSize === 'mobile' && isLandscape;

		const background = accessNested(this.props, 'appData.header.powsterHeader.bg');
		const backgroundElement = this.getBackgroundElement(background);

		return (
			<div
				class={joinClasses({
					s,
					container: true,
					open: navOpen,
					splitHeader: isSplitHeader,
					hasRegionSelector: showRegionSelector,
					hasManyLinks: totalLinks >= 8,
                    isMobileLandscape: isMobileLandscape
				})}
				style={(navOpen && paddingTop) && { top: `${paddingTop}px`, height: `calc(var(--windowHeight) - ${paddingTop}px)` }}
				body-scroll-lock-ignore={bannerPushDownMobile}
				inert={!navOpen}
			>
				{navOpen && backgroundElement}
                <video
                    autoplay
                    muted
                    loop
                    playsinline
                    class={s.backgroundVideo}
                    >
                    <source src="https://s3-eu-west-1.amazonaws.com/st-static-stage/universalstudios/how-to-train-your-dragon-intl/video/embers-video_burger.mp4" type="video/mp4" />
                </video>
				<div class={s.linksContainer} style={{ height: '100%' }}>
					<div class={s.links} role="navigation">
						{links}
					</div>
					{this.renderSocial()}
					{this.renderFooter()}
					{this.renderRegionSelector()}
				</div>
			</div>
		);
	}
}